import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Studio from "@/pages/Studio";
import Result from "@/pages/Result";
import Gallery from "@/pages/Gallery";
import Community from "@/pages/Community";
import Credits from "@/pages/Credits";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import SharedCreation from "@/pages/SharedCreation";
import MockupShare from "@/pages/MockupShare";
import Admin from "@/pages/Admin";
import { DropAlert } from "@/components/DropAlert";

const Loader = () => (
  <div className="min-h-[60vh] grid place-items-center" data-testid="page-loader">
    <div className="h-12 w-12 rounded-full border-4 border-[#FF5A79] border-t-transparent animate-spin" />
  </div>
);

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Navbar />
      <DropAlert />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/signup" element={<AuthPage mode="signup" />} />
        <Route path="/community" element={<Community />} />
        <Route path="/c/:id" element={<SharedCreation />} />
        <Route path="/m/:id" element={<MockupShare />} />
        <Route path="/admin" element={<Protected><Admin /></Protected>} />
        <Route path="/studio" element={<Protected><Studio /></Protected>} />
        <Route path="/creation/:id" element={<Protected><Result /></Protected>} />
        <Route path="/gallery" element={<Protected><Gallery /></Protected>} />
        <Route path="/credits" element={<Protected><Credits /></Protected>} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
